import * as React from 'react';
import { useCallback } from 'react';
import Collapse from '@mui/material/Collapse';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { useToggleable } from '../../../hooks';
import { Checkbox } from '../../../BaseComponents';
import { CdnIcon } from '@shared/ui';

export interface Props {
	className?: string;
	date: string;
	count?: number;
	info?: string;
	isOpen?: boolean;
	isSelected?: boolean;
	isDisabled?: boolean;
	onChangeCheckbox?: (checked: boolean) => void;
}

const SegmentCollapse: React.FC<Props> = ({
	className,
	children,
	count,
	date,
	info,
	isOpen = true,
	isSelected,
	isDisabled,
	onChangeCheckbox
}) => {
	const { SegmentCollapse: css } = useTheme('AdditionalServiceWrapper');

	const { isOpen: isCollapse, toggle } = useToggleable(isOpen);

	const onClick = useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.stopPropagation();
	}, []);

	const onChangeHandler = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			onChangeCheckbox?.(e.target.checked);
		},
		[onChangeCheckbox]
	);

	return (
		<div
			className={cn(css.segment, className, {
				[css.open]: isCollapse,
				[css.disabled]: isDisabled,
				[css.collapse]: !onChangeCheckbox
			})}
		>
			<div className={css.label__root} onClick={toggle}>
				<div className={css.label__label}>
					{onChangeCheckbox && (
						<Checkbox
							classes={{
								root: css.checkbox,
								checked: css.checkbox__checked
							}}
							checked={isSelected}
							disabled={isDisabled}
							onClick={onClick}
							onChange={onChangeHandler}
						/>
					)}

					<div className={css.label__title}>
						<span className={css.date}>{date}</span>
						{info && <span className={css.info}>{info}</span>}
						{count > 0 && <span className={css.count}>{count}</span>}
					</div>
				</div>

				<div className={css.arrow}>
					<CdnIcon icon="Arrow/Chevron_right" />
				</div>
			</div>

			<Collapse classes={{ wrapperInner: css.wrapperInner }} in={isCollapse}>
				{children}
			</Collapse>
		</div>
	);
};

export default SegmentCollapse;
